import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';

const styles = () => {
    return {
        root: {position: 'relative'},
    };
};

class VisualizationContainer extends PureComponent {
    render() {
        const {classes, children} = this.props;

        return (
            <section className={classes.root}>
                {children}
            </section>
        );
    }
}

VisualizationContainer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VisualizationContainer);
